<template>
    <v-btn
        dark
        color="#59C3C3"
        x-small
        fab
        @click="showItem(data)"
        outlined
    > <v-icon dark>
        mdi-eye
    </v-icon></v-btn>
</template>

<script>

    export default {
        props:{
            data:{},
            showItem: {
                type: Function,
            },
            meta: {
                type: Object,
                default: () => ({}),
            },
        }


    }
</script>
